import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Security} from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';

import 'semantic-ui-css/components/reset.min.css';
import 'semantic-ui-css/components/site.min.css';
import 'semantic-ui-css/components/container.min.css';
import 'semantic-ui-css/components/icon.min.css';
import 'semantic-ui-css/components/message.min.css';
import 'semantic-ui-css/components/header.min.css';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';

import Routes from './Routes';
import { SemanticToastContainer } from 'react-semantic-toasts';
import { AppMedia } from './NavBar/NavBarItems';
import RouteChangeTracker from './RouteChangeTracker';
import { MantineProvider } from '@mantine/core';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./MicrosoftAuth/authConfig";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import MaintenanceDisplay from './MaintenanceDisplay';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.oktaAuth = new OktaAuth({
        issuer: window._env_.REACT_APP_OKTA_ISSUER,
        clientId: window._env_.REACT_APP_OKTA_CLIENT,
        redirectUri: window.location.origin + '/login/okta/callback',
        onAuthRequired: this.onAuthRequired,
        pkce: true
    });
    this.restoreOriginalUri = async (_oktaAuth, originalUri) => {
      props.history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
    };
  }

  onAuthRequired() {
    this.props.history.push('/login');
  }

  render(){

    const mediaStyles = AppMedia.createMediaStyle()
    const {MediaContextProvider} = AppMedia
    const msalInstance = new PublicClientApplication(msalConfig)

    return (
        <div className='parent-container'>
            <MediaContextProvider>
            <style>{mediaStyles}</style>
            <SemanticToastContainer />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MsalProvider instance={msalInstance}>
                <Security oktaAuth={this.oktaAuth} restoreOriginalUri={this.restoreOriginalUri} >
                  <MantineProvider>
                      {window._env_.REACT_APP_MAINTENANCE === "true"?<MaintenanceDisplay />:<Routes />}
                  </MantineProvider>
                </Security>
              </MsalProvider>
              </LocalizationProvider>
            </MediaContextProvider>
        </div>
    )
}
}

const AppWithRouterAccess = App;

export default class AppRouter extends React.Component {
  render() {
    return (<Router history={RouteChangeTracker}><AppWithRouterAccess/></Router>);
  }
}